import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import {
	aceGray,
	brandPrimaryText,
	brandSecondary,
	gray3,
	gray4,
	hotPink,
	midGrey,
	success,
	titles,
} from '../../../styles/colors';
import { cardStyle, CssSelectors, Layouts } from '../../../styles/styles';

const {
	common: { borderRadius },
	spacing: { xs },
} = THEME;

export const styleSheet = StyleSheet.create({
	summary: {
		overflow: 'hidden',
		maxHeight: 80,
		// @ts-ignore
		display: '-webkit-box',
		'-webkit-box-orient': 'vertical',
		'-webkit-line-clamp': '4',
		margin: `16px 0`,
		paddingTop: 4,
		':has(*) img': {
			display: 'none',
		},
		':has(*) *': {
			fontFamily: 'Sora !important',
			fontSize: `14px !important`,
			background: 'transparent !important',
		},
	},
	body: {
		background: 'transparent !important',
		color: gray3,
		fontFamily: 'Sora !important',
		fontSize: '14px !important',
	},
	buttonCompound: {
		height: 24,
		minWidth: 90,
	},
	buttonStack: {
		justifyContent: 'space-between',
		alignItems: 'center',
		flexDirection: 'row',
		paddingLeft: 2,
		whiteSpace: 'nowrap',
	},
	container: {
		...cardStyle,
		overflow: 'visible',
		boxSizing: 'border-box',
		display: 'inline-flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		position: 'relative',
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: xs,
				marginLeft: xs,
				marginTop: -xs,
				display: 'inline-block',
			},
			'span[data-placeholder="true"]'
		),
	},
	featured: {
		background: 'linear-gradient(156.83deg, #F5FAFD 14.57%, #E8F3F9 42%, #E8F3F9 85.02%)',
	},
	flagHighlight: {
		marginTop: 50,
	},
	headerContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: 2,
	},
	menu: {
		position: 'absolute',
		right: 5,
		top: 5,
		width: 30,
		color: aceGray,
		fontSize: 20,
		marginLeft: 'auto',
	},
	menuItem: {
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		fontSize: 14,
		padding: '4px 16px',
		textAlign: 'center',
		width: '100%',
		':hover': {
			background: '#F3F8FB',
		},
	},
	nameContainer: {
		borderTopLeftRadius: 9,
		borderTopRightRadius: 9,
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		gap: 8,
		alignItems: 'center',
		fontSize: 16,
		overflow: 'hidden',
		paddingTop: 30,
		textOverflow: 'ellipsis',
		width: '100%',
		...CssSelectors.allChildren(
			{
				maxWidth: '100%',
			},
			'div'
		),
	},
	newItem: {
		color: hotPink,
	},
	sharedItem: {
		color: brandSecondary,
		fontSize: '12px',
		fontStyle: 'italic',
		marginLeft: 8,
	},
	sharedByFooter: {
		color: THEME.colors.text.light,
		fontSize: '11px',
		fontStyle: 'italic',
		textAlign: 'center',
		padding: '8px 15px 0px 15px',
		marginTop: 8,
	},
	noPaddingTop: {
		paddingTop: 0,
		marginTop: 15,
	},
	openLetter: {
		height: 82,
		position: 'absolute',
		right: -10,
		top: -10,
		transform: 'translate3d(0px, -10px, 0)',
	},
	popover: {
		borderBottomRightRadius: 0,
		boxSizing: 'border-box',
		color: gray4,
		fontSize: 12,
		lineHeight: '18px',
		marginLeft: 14,
		maxWidth: 240,
		padding: '6px 6px 6px 6px',
	},
	popoverAnchor: {
		zIndex: 5,
	},
	popoverContainer: {
		marginRight: 25,
	},
	reviewed: {
		color: success,
		marginRight: 20,
	},
	reviewedStack: {
		marginTop: 20,
		...Layouts.horizontalStack(1),
		alignItems: 'center',
		color: gray3,
		display: 'flex',
		fontSize: 11,
		marginLeft: 10,
	},
	sendNow: {
		height: 82,
		left: -8,
		position: 'absolute',
		top: -16,
	},
	sharedBy: {
		fontSize: 11,
		fontStyle: 'italic',
		color: `${midGrey} !important`,
		opacity: 0.8,
	},
	subject: {
		color: brandPrimaryText,
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 15,
		padding: 0,
		wordBreak: 'break-all',
	},
	socialMediaTag: {
		translate: '18px -18px',
	},
	tagButtonContent: {
		display: 'flex',
		flexDirection: 'row',
	},
	tagButtonContentCenter: {
		alignItems: 'center',
	},
	textContainer: {
		minHeight: 64,
		flex: 1,
		marginBottom: 15,
	},
	textContainerSmall: {
		minHeight: 0,
	},
	textContent: {
		color: `${gray3} !important`,
		fontFamily: 'Sora !important',
		fontSize: '14px !important',
		marginBottom: 0,
		marginTop: 0,
		paddingBottom: 0,
		paddingRight: 20,
		paddingTop: 12,
		lineHeight: '1.5',
		margin: 0,
		width: '100%',
		boxSizing: 'border-box',
	},
	textContentSmall: {
		fontSize: '12px !important',
		height: 'auto',
	},
	textContentTwoLines: {
		display: '-webkit-box' as any,
		'-webkit-line-clamp': 2 as any,
		'-webkit-box-orient': 'vertical' as any,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		lineHeight: '1.5',
		maxHeight: '3rem', // 2 lines at 1.5 line-height
	},
	userName: {
		display: 'inline-flex',
		fontSize: 11,
		lineHeight: '15px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	alignCenter: {
		alignItems: 'center',
	},
	approvedText: {
		color: success,
		fontWeight: 'bold',
		marginLeft: 12,
	},
});
